import { Box, styled } from "@mui/material";

export const DropTarget = styled(Box)`
  width: 100%;
  height: 100%;
`
